export const lightVariant = {
  root: {
    border: 'none',
    backgroundColor: 'neutral.600',
    padding: 1,
  },
  closeTrigger: {
    width: '24px',
    height: '24px',
    color: 'neutral.300',
    '&:not([data-disabled=true]):hover': {
      color: 'skyBlue',
      cursor: 'pointer',
    },
  },
};
